import type {DomainRealtimeHandler} from "../../../shared/realtime/realtime.types";

import {userKeys} from "../user-keys";

export const usersRealtimeHandler: DomainRealtimeHandler = {
  resource: "users",
  handleEvent: (event, queryClient) => {
    if (event.action === "CREATED" || event.action === "DELETED") {
      void queryClient.invalidateQueries({queryKey: userKeys.lists()});
    } else if (event.action === "UPDATED") {
      // Invalidates both detail views and list views containing this user
      void queryClient.invalidateQueries({queryKey: userKeys.all});
    }
  },
};
